package org.example.zone360.pages.widgets.topicDiversty

import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.css.ScrollBehavior
import com.varabyte.kobweb.compose.css.WhiteSpace
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.alignSelf
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.borderBottom
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxHeight
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.scrollBehavior
import com.varabyte.kobweb.compose.ui.modifiers.whiteSpace
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.modifiers.zIndex
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.icons.fa.FaArrowDown
import com.varabyte.kobweb.silk.components.icons.fa.FaArrowUp
import com.varabyte.kobweb.silk.components.icons.fa.FaX
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import org.example.zone360.utils.getWidgetDetail
import kotlinx.browser.document
import kotlinx.coroutines.delay
import org.example.zone360.components.debugPrintln
import org.example.zone360.components.getAvatarColor
import org.example.zone360.componentss.FieldTitleTextNormalSimple
import org.example.zone360.models.WidgetCoach
import org.example.zone360.models.WidgetDetailPayload
import org.example.zone360.models.WidgetDetailResponse
import org.example.zone360.theme.Palette
import org.example.zone360.theme.toSitePalette
import org.example.zone360.utils.AppGlobal
import org.jetbrains.compose.web.css.AlignSelf
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.vh
import org.jetbrains.compose.web.dom.Canvas
import org.w3c.dom.HTMLCanvasElement

@Composable
fun TopicDiversityDetailsModal(
    widgetNo: Int,
    widgetName: String,
    widgetColor: Color,
    score: Int,
    clubAverage: Int,
    isCoachPage: Boolean,
    hasData: Boolean,
    coaches: List<WidgetCoach>?,
    entries: List<TopicDiversityEntry>,
    widgetKey: String,
    onClose: () -> Unit,
) {
    val breakpoint = rememberBreakpoint()
    val sitePalette = ColorMode.current.toSitePalette()
    var selectedSortColumn by remember { mutableStateOf<String?>(null) }
    var isAscending by remember { mutableStateOf(true) }
    var localData by remember { mutableStateOf<WidgetDetailResponse?>(null) }
    var isLoading by remember { mutableStateOf(true) }
    var localClubAverage by remember { mutableStateOf(clubAverage) }
    var localCoaches by remember { mutableStateOf(coaches ?: emptyList()) }


    val maxEntries = 7
    val topEntries = entries
        .sortedByDescending { it.percentage }  // Highest first
        .take(maxEntries)
    // Add after state declarations
    LaunchedEffect(Unit) {
        isLoading = true
        try {
            localData = getWidgetDetail(
                WidgetDetailPayload(
                    organization = AppGlobal.userData.organization,
                    seasonID = AppGlobal.selectedSeasonId,
                    widgetKey = widgetKey
                )
            )

            // Update local data if fetched
            if (localData != null) {
                localClubAverage = localData?.clubAverage?.toInt() ?: clubAverage
                localCoaches = localData?.coaches?.map { coach ->
                    WidgetCoach(
                        coachName = coach.coachName,
                        score = coach.score
                    )
                } ?: emptyList()
            }
        } catch (e: Exception) {
            debugPrintln("Failed to fetch widget detail: ${e.message}")
        } finally {
            isLoading = false
        }
    }

    val effectiveCoaches = if (localData != null) localCoaches else (coaches ?: emptyList())
    val effectiveClubAverage = if (localData != null) localClubAverage else clubAverage
    val sortedCoaches = when (selectedSortColumn) {
        "COACH" -> if (isAscending)
            effectiveCoaches.sortedBy { it.coachName.lowercase() }
        else
            effectiveCoaches.sortedByDescending { it.coachName.lowercase() }

        "SCORE" -> if (isAscending)
            effectiveCoaches.sortedBy { it.score }
        else
            effectiveCoaches.sortedByDescending { it.score }

        else -> effectiveCoaches
    }
    val chartId = "topicDetailChart_$widgetNo"
    val windowKey = "topicDetailChart_$widgetNo"

    val fallbackColors = listOf(
        "#4F8EF7", "#FB6F2A", "#22C55E", "#F59E0B", "#8B5CF6", "#06B6D4"
    )

//    val colorsJs = entries.mapIndexed { i, e ->
//        "\"${e.colorHex.ifBlank { fallbackColors[i % fallbackColors.size] }}\""
//    }.joinToString(",", "[", "]")
    val colorsJs =
        if (hasData) {
            entries.mapIndexed { i, e ->
                "\"${e.colorHex.ifBlank { fallbackColors[i % fallbackColors.size] }}\""
            }.joinToString(",", "[", "]")
        } else {
            "[\"${Palette.TopicDiversityPink.rgbLight}\"]"
        }
    val labelsJs = entries.joinToString(",", "[", "]") { "\"${it.label}\"" }
    val dataJs =
        if (hasData) {
            entries.joinToString(",", "[", "]") { it.percentage.toString() }
        } else {
            "[100]"
        }
//    val dataJs = entries.joinToString(",", "[", "]") { it.percentage.toString() }

    val borderWidth = if (hasData) 3 else 0
    val centerScore = if (hasData) "$score%" else "0%"


    DisposableEffect(chartId) {
        onDispose {

            val s = document.createElement("script")

            s.textContent = """
(function(){

    var k='$windowKey';

    console.log("DISPOSE", k, window[k]);

    try{

        if(
            window[k] &&
            typeof window[k].destroy === 'function'
        ){
            window[k].destroy();
        }

    }catch(e){
        console.error("Dispose destroy failed", e);
    }

    window[k] = null;

})();
""".trimIndent()

            document.body?.appendChild(s)
        }
    }

    LaunchedEffect(entries, score, isLoading) {
        if (isLoading) return@LaunchedEffect

        delay(100)

        val canvas = document.getElementById(chartId) as? HTMLCanvasElement

        if (canvas == null) {
            console.error("Canvas not found")
            return@LaunchedEffect
        }

        val script = """
(function(){

    var k='$windowKey';

    console.log("======== MODAL CHART ========");
    console.log("windowKey =", k);
    console.log("existing =", window[k]);
    console.log("type =", typeof window[k]);

    try {

        console.log("Before destroy =", window[k]);

        if(
            window[k] &&
            typeof window[k].destroy === 'function'
        ){
            console.log("Destroying chart");
            window[k].destroy();
        }

    } catch (e) {
        console.error("Destroy failed", e);
    }

    window[k] = null;

    var canvas = document.getElementById('$chartId');

    console.log("Canvas =", canvas);

    if(!canvas){
        console.error("Canvas missing");
        return;
    }

    canvas.width = 220;
    canvas.height = 220;

    var centerPlugin = {
        id:'center_$chartId',
        afterDraw:function(chart){

            var ctx = chart.ctx;

            ctx.save();

            ctx.font='bold 26px sans-serif';
            ctx.fillStyle='#1F2937';
            ctx.textAlign='center';
            ctx.textBaseline='middle';

            ctx.fillText(
                '$score%',
                chart.width / 2,
                chart.height / 2
            );

            ctx.restore();
        }
    };

    window[k] = new Chart(canvas,{
        type:'doughnut',
        data:{
            labels:$labelsJs,
            datasets:[{
                backgroundColor:$colorsJs,
                data:$dataJs,
                borderWidth:$borderWidth,
                borderColor:'#ffffff'
            }]
        },
        options:{
            plugins:{
                legend:{display:false},
                title:{display:false}
            },
            cutout:'68%',
            responsive:false,
            maintainAspectRatio:false
        },
        plugins:[centerPlugin]
    });

    console.log("Created chart =", window[k]);
    console.log("Has destroy =", typeof window[k].destroy);

})();
""".trimIndent()

        val existing =
            document.getElementById("topicDetailScript_$chartId")

        existing?.remove()

        val scriptEl = document.createElement("script")

        scriptEl.id = "topicDetailScript_$chartId"
        scriptEl.textContent = script

        document.body?.appendChild(scriptEl)
    }

    // ── Overlay ───────────────────────────────────────────────────────────────
    Box(
        modifier = Modifier
            .fillMaxSize()
            .position(Position.Fixed)
            .styleModifier {
                property("top", "0")
                property("left", "0")
            }
            .zIndex(99999)
            .backgroundColor(Color.rgba(0, 0, 0, 0.5f))
            .onClick { onClose() },
        contentAlignment = Alignment.Center
    ) {
        // ── Modal card ────────────────────────────────────────────────────────
        Box(
            modifier = Modifier
                .width(if (breakpoint < Breakpoint.MD) 350.px else 450.px)
                .maxHeight(90.vh)
                .backgroundColor(sitePalette.modalBackgroundColor.rgb)
                .borderRadius(16.px)
                .overflow(Overflow.Auto)
                .scrollBehavior(ScrollBehavior.Smooth)
                .onClick { it.stopPropagation() }  // prevent overlay close
                .padding(24.px)
                .styleModifier { property("position", "relative") }
        ) {
            Column(modifier = Modifier.fillMaxWidth()) {

                // ── Modal header ──────────────────────────────────────────────
                Row(
                    verticalAlignment = Alignment.CenterVertically,
                    horizontalArrangement = Arrangement.SpaceBetween,
                    modifier = Modifier.fillMaxWidth().margin(bottom = 24.px)
                ) {
                    Row(verticalAlignment = Alignment.CenterVertically) {
                        Box(
                            modifier = Modifier
                                .width(32.px).height(32.px)
                                .backgroundColor(widgetColor)
                                .borderRadius(8.px)
                                .margin(right = 12.px),
                            contentAlignment = Alignment.Center
                        ) {
                            FieldTitleTextNormalSimple(
                                text = widgetNo.toString(),
                                fontSize = 15.px,
                                fontWeight = 700,
                                color = sitePalette.bodyBackgroundSecondary.rgb
                            )
                        }
                        FieldTitleTextNormalSimple(
                            text = widgetName,
                            fontSize = 20.px,
                            fontWeight = 700
                        )
                    }

                    // Close button
                    Box(
                        modifier = Modifier
                            .width(32.px).height(32.px)
                            .borderRadius(50.percent)
                            .backgroundColor(Color.rgb(243, 244, 246))
                            .cursor(Cursor.Pointer)
                            .onClick { onClose() },
                        contentAlignment = Alignment.Center
                    ) {
                        FaX(
                            modifier = Modifier
                                .fontSize(14.px)
                                .color(Color.rgb(107, 114, 128))
                        )
                    }
                }

                // ── Donut + Legend row ────────────────────────────────────────
//                if (isLoading) {
//                    Box(
//                        modifier = Modifier
//                            .fillMaxWidth()
//                            .height(300.px),
//                        contentAlignment = Alignment.Center
//                    ) {
//                        Column(horizontalAlignment = Alignment.CenterHorizontally) {
//                            ProgressIndicator(size = 30.px)
//                        }
//                    }
//                } else {
                    Row(
                        verticalAlignment = Alignment.CenterVertically,
                        horizontalArrangement = Arrangement.SpaceAround,
                        modifier = Modifier.fillMaxWidth().margin(bottom = 24.px)
                    ) {
                        // Large donut
                        val canvasSize = if (breakpoint < Breakpoint.MD) 130.px else 180.px
                        Canvas(
                            attrs = Modifier
                                .width(canvasSize)
                                .height(canvasSize)
                                .id(chartId)
                                .toAttrs {
                                    attr("width", canvasSize.value.toInt().toString())
                                    attr("height", canvasSize.value.toInt().toString())
                                }
                        ) {}
                        // Legend
                        Column(modifier = Modifier.margin(left = 24.px)) {
                            topEntries.forEachIndexed { i, entry ->
                                Row(
                                    verticalAlignment = Alignment.CenterVertically,
                                    modifier = Modifier
                                        .margin(bottom = 12.px)
                                        .styleModifier { property("width", "100%") }
                                ) {
                                    // Dot
                                    Box(
                                        modifier = Modifier
                                            .width(11.px).height(11.px)
                                            .borderRadius(50.percent)
                                            .margin(right = 8.px)
                                            .styleModifier {
                                                property(
                                                    "background-color",
                                                    entry.colorHex.ifBlank {
                                                        fallbackColors[i % fallbackColors.size]
                                                    }
                                                )
                                                property("flex-shrink", "0")
                                            }
                                    )
                                    // Label — grows
                                    Box(modifier = Modifier.styleModifier {
                                        property(
                                            "flex",
                                            "1"
                                        )
                                    }) {
                                        FieldTitleTextNormalSimple(
                                            text = entry.label,
                                            fontSize = 13.px,
                                            fontWeight = 500,
                                            color = Palette.CoachTalkTableHeaderText.rgbLight
                                        )
                                    }
                                    // % — right aligned fixed width
                                    Box(
                                        modifier = Modifier.width(36.px),
                                        contentAlignment = Alignment.CenterEnd
                                    ) {
                                        FieldTitleTextNormalSimple(
                                            text = "${entry.percentage}%",
                                            fontSize = 13.px,
                                            fontWeight = 700
                                        )
                                    }
                                }
                            }
                        }
                    }

                    // ── Club avg ──────────────────────────────────────────────────
                    Box(
                        modifier = Modifier
                            .backgroundColor(Palette.WidgetAverageBackground.rgbLight)
                            .borderRadius(99.px)
                            .alignSelf(AlignSelf.Center)
                            .margin(bottom = 15.px)
                            .padding(leftRight = 10.px, topBottom = 4.px),
                        contentAlignment = Alignment.Center
                    ) {
                        FieldTitleTextNormalSimple(
                            text = "Club Avg: $effectiveClubAverage%",
                            fontSize = 11.px,
                            fontWeight = 500,
                            color = Palette.WidgetAverageText.rgbLight
                        )
                    }
//                }

                // ── Coach table ───────────────────────────────────────────────
                Column(
                    modifier = Modifier
                        .fillMaxWidth()
                        .borderRadius(12.px)
                        .styleModifier {
                            property("border", "1px solid #E5EAF3")
                            property("overflow", "hidden")
                        }
                ) {
                    // Header
                    Row(
                        modifier = Modifier
                            .fillMaxWidth()
                            .gap(10.px)
                            .backgroundColor(Color.rgb(248, 250, 252))
                            .padding(leftRight = 20.px, topBottom = 10.px)
                            .borderBottom(1.px, LineStyle.Solid, Color.rgb(229, 234, 243)),
                        horizontalArrangement = Arrangement.SpaceBetween,
                        verticalAlignment = Alignment.CenterVertically
                    ) {
                        listOf("COACH", "SCORE").forEachIndexed { index, label ->
                            Row(
                                modifier = Modifier
                                    .width(
                                        when (index) {
                                            0 -> 140.px
                                            else -> 80.px
                                        }
                                    )
                                    .cursor(if (index < 2) Cursor.Pointer else Cursor.Default)
                                    .onClick {
                                        if (index < 2) {
                                            if (selectedSortColumn == label) isAscending =
                                                !isAscending
                                            else {
                                                selectedSortColumn = label; isAscending = true
                                            }
                                        }
                                    },
                                verticalAlignment = Alignment.CenterVertically
                            ) {
                                FieldTitleTextNormalSimple(
                                    text = label,
                                    fontSize = 11.px,
                                    fontWeight = 700,
                                    color = Color.rgb(107, 114, 128)
                                )
                                if (selectedSortColumn == label) {
                                    Box(modifier = Modifier.margin(left = 5.px)) {
                                        if (isAscending) FaArrowUp(
                                            modifier = Modifier.fontSize(10.px)
                                                .color(Palette.CoachHeaderGradientOne.rgbLight)
                                        ) else FaArrowDown(
                                            modifier = Modifier.fontSize(9.px)
                                                .color(Palette.CoachHeaderGradientOne.rgbLight)
                                        )
                                    }
                                }
                            }
                        }
                    }

                    // Body
                    Column(
                        modifier = Modifier
                            .fillMaxWidth()
                            .height(260.px)
                            .overflow(Overflow.Auto)
                    ) {
                        sortedCoaches.forEachIndexed { rowIndex, coach ->
                            val avatarColor = getAvatarColor(coach.coachName)
                            val initials = coach.coachName
                                .split(" ").take(1)
                                .joinToString("") { it.firstOrNull()?.toString() ?: "" }
                                .uppercase()
                            Row(
                                modifier = Modifier
                                    .fillMaxWidth()
                                    .gap(10.px)
                                    .backgroundColor(
                                        if (rowIndex % 2 == 0) Colors.White
                                        else Color.rgb(250, 251, 252)
                                    )
                                    .padding(leftRight = 20.px, topBottom = 10.px)
                                    .borderBottom(
                                        1.px,
                                        LineStyle.Solid,
                                        Color.rgb(241, 245, 249)
                                    ),
                                horizontalArrangement = Arrangement.SpaceBetween,
                                verticalAlignment = Alignment.CenterVertically
                            ) {
                                // Coach
                                Row(
                                    modifier = Modifier,
                                    verticalAlignment = Alignment.CenterVertically
                                ) {
                                    Box(
                                        modifier = Modifier
                                            .width(32.px).height(32.px)
                                            .backgroundColor(avatarColor.bg)
                                            .borderRadius(50.percent)
                                            .margin(right = 8.px),
                                        contentAlignment = Alignment.Center
                                    ) {
                                        SpanText(
                                            text = initials,
                                            modifier = Modifier
                                                .fontSize(11.px).fontWeight(700)
                                                .color(avatarColor.text)
                                        )
                                    }
                                    SpanText(
                                        text = coach.coachName,
                                        modifier = Modifier
                                            .fontSize(13.px).fontWeight(500)
                                            .overflow(Overflow.Hidden)
                                            .whiteSpace(WhiteSpace.NoWrap)
                                            .styleModifier {
                                                property(
                                                    "text-overflow",
                                                    "ellipsis"
                                                )
                                            }
                                    )
                                }

                                // Score
                                Box(modifier = Modifier.width(70.px)) {
                                    FieldTitleTextNormalSimple(
                                        text = "${coach.score}",
                                        fontSize = 11.px,
                                        fontWeight = 500
                                    )
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}